import { Card, Empty, theme } from 'antd';
import { FC } from 'react';
import { GraphUp } from 'react-bootstrap-icons';

import './SearchConsoleAnalyticsChart.scss';

export const SearchConsoleAnalyticsNoChartView: FC = () => {
  const { token: { colorBgLayout } } = theme.useToken();
  return (
    <Card
      className="search-console-analytics-no-chart"
      style={{ backgroundColor: colorBgLayout, }}
      styles={{
        body: {
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }
      }}
    >
      <Empty description="Недостатньо даних для побудови діаграми" image={ <GraphUp size={ 72 }/> }/>
    </Card>
  );
};
